<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.channel_table_search') ||
                  'ITEM/CHSKU/EAN/渠道名称/品牌名称/渠道售卖名称/店铺售卖渠道 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_skuplatform_status') || '产品状态'"
            >
              <dict-select
                v-model="form.listEvgSkuPlatformStatus"
                url="/master/common/dict/biz"
                :body="{ dictType: 'evgSkuPlatformStatus' }"
                :placeholder="
                  $l('INDEX.evg_sku_platform_placeholder_status') ||
                    '请选择状态'
                "
                size="mini"
                style="width: 100%"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.evg_sku_platform_sellType') || '售卖类型'"
            >
              <dict-select
                v-model="form.listSellType"
                url="/sys/common/dict/system"
                :body="{ dictType: 'evgSellType' }"
                :placeholder="$l('INDEX.evg_sku_platform_placeholder_sellType') || '请选择售卖类型'"
                size="mini"
                style="width: 100%"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.evg_sku_platform_channelItemNo') || '渠道Item号'"
            >
              <el-input
                v-model.trim="form.channelItemNo"
                :placeholder="$l('INDEX.evg_sku_platform_placeholder_channelItemNo') || '请输入渠道Item号'"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.evg_sku_platform_channelSkuNo') || '渠道款号'"
            >
              <el-input
                v-model.trim="form.channelSkuNo"
                :placeholder="$l('INDEX.evg_sku_platform_placeholder_channelSkuNo') || '请输入渠道款号'"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.evg_sku_platform_channelEanNo') || '渠道条码号'"
            >
              <el-input
                v-model.trim="form.channelEanNo"
                :placeholder="$l('INDEX.evg_sku_platform_placeholder_channelEanNo') || '请输入渠道条码号'"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.evg_sku_sale_platform') || '销售渠道'"
            >
              <dict-select
                v-model="form.listPlatformCode"
                url="/ecom/evg/platform/select"
                :placeholder="$l('INDEX.evg_sku_placeholder_sale_platform') || '请选择销售渠道'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('INDEX.evg_sku_platform_brand') || '品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('INDEX.evg_sku_platform_placeholder_brand') || '请选择品牌'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('INDEX.evg_sku_platform_operate') || '运营人员'">
              <dict-select
                v-model="form.listOperateCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.evg_sku_platform_placeholder_operate') || '请选择运营人员'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.evg_sku_platform_salesTitle') || '渠道售卖标题'
              "
            >
              <el-input
                v-model.trim="form.salesTitle"
                :placeholder="$l('INDEX.evg_sku_platform_placeholder_salesTitle') || '请输入渠道售卖标题'"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.evg_sku_platform_storeSalesPrice') || '正常卖价'"
              >
                <br />
                <el-col :span="11">
                  <el-input-number
                    v-model="form.salesPriceStart"
                    :placeholder="
                      $l('INDEX.evg_sku_platform_placeholder_storeSalesPrice') || '请输入正常卖价'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.salesPriceEnd"
                    :placeholder="
                      $l('INDEX.evg_sku_platform_placeholder_storeSalesPrice') || '请输入正常卖价'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.evg_sku_platform_salesCurrencyUnit') || '卖价货币单位'
              "
            >
              <dict-select
                v-model="form.listSalesCurrencyUnit"
                url="/master/common/dict/biz"
                :body="{ dictType: 'currencyUnit' }"
                :placeholder="
                  $l('INDEX.evg_sku_platform_placeholder_salesCurrencyUnit') ||
                    '请选择卖价货币单位'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-row :gutter="10">
              <el-form-item
                :label="
                  $l('INDEX.evg_sku_platform_firstOnShelvesDate') || '首次上架日期'
                "
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.firstOnShelvesDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.evg_sku_platform_placeholder_first_date_start') || '选择首次上架日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.firstOnShelvesDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.evg_sku_platform_placeholder_first_date_end') || '选择首次上架日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.evg_sku_platform_create_date') || '创建时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.evg_sku_platform_placeholder_create_date_start') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.evg_sku_platform_placeholder_create_date_end') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.evg_sku_platform_modify_date') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.evg_sku_platform_placeholder_modify_date_start') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.evg_sku_platform_placeholder_modify_date_end') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listEvgSkuPlatformStatus: [], listSellType: [] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
